import { inject, InjectionToken } from '@angular/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

export const isDutch = new InjectionToken<boolean>('isDutch', {
  providedIn: 'root',
  factory: () => {
    const localizeRouterService = inject(LocalizeRouterService);
    const userLang =
      localizeRouterService.parser.getLocationLang() || localizeRouterService.parser.defaultLang;
    console.log('userLang', userLang);
    return userLang.startsWith('nl');
  },
});
